export class Customer {
    constructor({
        companyName = null,
        abn = null,
        acn = null,
        customerType = null,
        address = null,
        salutation = null,
        contactFirstName = null,
        contactLastName = null,
        contactPhone = null,
        contactMobile = null,
        contactEmail = null,
        billingEmail = null,
        alternateCustomerID = null,
        hostedPbxDomain = null,
        uBDealerId = null,
        groupNo = null,
        success = null,
        reason = null,
    } = {}) {
        this.companyName = companyName;
        this.abn = abn;
        this.acn = acn;
        this.customerType = customerType;
        this.address = address;
        this.salutation = salutation;
        this.contactFirstName = contactFirstName;
        this.contactLastName = contactLastName;
        this.contactPhone = contactPhone;
        this.contactMobile = contactMobile;
        this.contactEmail = contactEmail;
        this.billingEmail = billingEmail;
        this.alternateCustomerID = alternateCustomerID;
        this.hostedPbxDomain = hostedPbxDomain;
        this.uBDealerId = uBDealerId;
        this.groupNo = groupNo;
        this.success = success;
        this.reason = reason;
    }
}
export function createCustomer(data) {
    return Object.freeze(new Customer(data));
}
